import * as React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import * as moment from "moment-timezone";
import {action, computed, observable} from "mobx";
import {observer} from "mobx-react";
import {HRTab} from "components/hr/widgets/HRTab";

import './HRRegisterChart.pcss';
import {IParticipant} from "data/hr/IHRDashboardData";
import {UIState} from "data/UIState";


interface Props {
  registrationData:IParticipant[];
}

@observer
export default class HRRegisterChart extends React.Component<Props> {
  // static demoUrl = 'https://codesandbox.io/s/stacked-bar-chart-s47i2';
  static colors = [
    "#8884d8",
    "#82ca9d",
  ];

  days:any[];
  totals:any;

  totalsData:any[];
  dailyData:any[];

  @observable showTotals = true;
  @observable showDaily = false;
  @observable initialized = false;

  @computed get data() {
    return this.showTotals ? this.totalsData : this.dailyData;
  }

  @computed get title() {
    return this.showTotals ? "Registration Totals" : "Daily Registrations";
  }

  initData = () => {
    const registrationData = this.props.registrationData;
    // init types
    this.totals = {};
    for(let i=0;i<registrationData.length;i++) {
      if(!this.totals[registrationData[i].employeeOrSpouse]) {
        this.totals[registrationData[i].employeeOrSpouse] = 0;
      }
    }

    this.days = [];
    const day1Moment = moment(registrationData[0].dateCreated);
    let dayIndex = 0;
    this.days[dayIndex] = {
      dayMoment:day1Moment.clone(),
      dayLabel: day1Moment.tz(UIState.settings.DEPLOYMENT_TIMEZONE).format('MMM D'),
      dayCount:{},
      totalCount:{},
    };
    const totalsKeys = Object.keys(this.totals);
    for(let t=0;t<totalsKeys.length;t++) {
      this.days[dayIndex].dayCount[totalsKeys[t]] = 0;
      this.days[dayIndex].totalCount[totalsKeys[t]] = 0;
    }

    for(let i=0;i<registrationData.length;i++) {
      let dayMoment = moment(registrationData[i].dateCreated);
      let currentDayMoment = this.days[dayIndex].dayMoment
      while(!dayMoment.isSame(currentDayMoment, 'day')) {
        currentDayMoment = currentDayMoment.add(1, 'day');
        dayIndex++;
        this.days[dayIndex] = {
          dayMoment:currentDayMoment.clone(),
          dayLabel: currentDayMoment.tz(UIState.settings.DEPLOYMENT_TIMEZONE).format('MMM D'),
          dayCount:{},
          totalCount:{},
        };
        for(let t=0;t<totalsKeys.length;t++) {
          this.days[dayIndex].dayCount[totalsKeys[t]] = 0;
          this.days[dayIndex].totalCount[totalsKeys[t]] = 0;
        }
      }

      this.totals[registrationData[i].employeeOrSpouse]++;
      this.days[dayIndex].dayCount[registrationData[i].employeeOrSpouse]++;
      for(let t=0;t<totalsKeys.length;t++) {
        this.days[dayIndex].totalCount[totalsKeys[t]] = this.totals[totalsKeys[t]];
      }
    }


    this.totalsData = [];
    for(let i=0;i<this.days.length;i++) {
      let obj:any = {
        name:this.days[i].dayLabel,
        ...this.days[i].totalCount
      };
      this.totalsData.push(obj);
    }

    this.dailyData = [];
    for(let i=0;i<this.days.length;i++) {
      let obj:any = {
        name:this.days[i].dayLabel,
        ...this.days[i].dayCount
      };
      this.dailyData.push(obj);
    }
    this.initialized = true;
  }

  constructor(props:Props) {
    super(props);
   //makeObservable(this);
    this.initData();
  }


  render() {

    if(!this.initialized) {
      return null;
    } else {
      return (
        <div className={"hr-registerChart"}>
          <div className={"tabs"}>
            <HRTab selected={this.showTotals} onClick={action(() => {
              this.showDaily = false;
              this.showTotals = true;
            })}>TOTALS</HRTab>
            <HRTab selected={this.showDaily} onClick={action(() => {
              this.showTotals = false;
              this.showDaily = true;
            })}>DAILY</HRTab>
          </div>
          <h3>{this.title}</h3>
          <ResponsiveContainer width="100%" height={200}>
            <BarChart
              width={500}
              height={300}
              data={this.data}
              margin={{
                top: 20,
                right: 30,
                left: 0,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3"/>
              <XAxis dataKey="name"/>
              <YAxis/>
              <Tooltip/>
              <Legend
                formatter={(value, entry, index) => <span className="legend-label-color">{value}</span>}
              />
              {Object.keys(this.totals).map((key, idx) =>
                <Bar
                  maxBarSize={50}
                  key={key}
                  dataKey={key}
                  stackId="a"
                  fill={HRRegisterChart.colors[idx % HRRegisterChart.colors.length]}
                />
              )}
            </BarChart>
          </ResponsiveContainer>
        </div>
      );
    }
  }
}
